module.exports = __webpack_public_path__ + "static/media/high-fidelity-wireframes.e09705ce.png";